export default "<div [id]=\"mapId != undefined ? mapId : 'miniMap'\" style=\"width: 100%; height: 100%;\"></div>\n"